// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__aPdz_","box":"WorkspacesBox_box__1SpKz","node":"WorkspacesBox_node__mTy1M"};